import type { Locale } from "@mazzager/contracts";

const copy = {
  ru: {
    signIn: "Войти", createAccount: "Создать аккаунт", name: "Имя", username: "Username", password: "Пароль", email: "Почта",
    repeatPassword: "Повторите пароль", continue: "Продолжить", verify: "Подтвердить", verificationTitle: "Проверьте почту",
    verificationHint: "Мы отправили шестизначный код. Аккаунт появится только после подтверждения.", messages: "Сообщения",
    discover: "Обзор", groups: "Группы", people: "Люди", search: "Поиск", message: "Сообщение", online: "в сети",
    download: "Скачать APK", installTitle: "Mazzager для Android", installText: "Нативное приложение работает быстрее и остаётся на связи.",
    send: "Отправить", weak: "Слабый", medium: "Нормальный", strong: "Надёжный", demo: "Открыть демо",
    heroTitle: "Разговоры без лишнего шума.", heroText: "Личные чаты, сообщества и звонки — одинаково быстро в браузере и на Android.",
    newGroup: "Новая группа", settings: "Настройки", noConversation: "Выберите чат, чтобы начать разговор", typing: "печатает…",
  },
  en: {
    signIn: "Sign in", createAccount: "Create account", name: "Name", username: "Username", password: "Password", email: "Email",
    repeatPassword: "Repeat password", continue: "Continue", verify: "Verify", verificationTitle: "Check your inbox",
    verificationHint: "We sent a six-digit code. Your account is created only after verification.", messages: "Messages",
    discover: "Discover", groups: "Groups", people: "People", search: "Search", message: "Message", online: "online",
    download: "Download APK", installTitle: "Mazzager for Android", installText: "The native app is faster and keeps you connected.",
    send: "Send", weak: "Weak", medium: "Good", strong: "Strong", demo: "Open demo",
    heroTitle: "Conversations without the noise.", heroText: "Private chats, communities and calls — equally fast in your browser and on Android.",
    newGroup: "New group", settings: "Settings", noConversation: "Choose a chat to start a conversation", typing: "typing…",
  },
} as const;

export type Copy = { [Key in keyof typeof copy.ru]: string };
export const t = (locale: Locale): Copy => copy[locale];
